import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { FaShoppingBasket } from 'react-icons/fa';

import styles from './BasketBar.module.css';

const hiddenAt = ['/basket', '/checkout', '/login', '/map', '/userdata'];

function BasketBar({ visible = false }) {
  const location = useLocation();

  if (!visible || !hiddenAt.every(path=>!location.pathname.includes(path))) return <></>;

  return (
    <div className={styles.basketBarContent}>
      <Link to="/basket" className={styles.basketBar}>
        <FaShoppingBasket size={20} color="#FFF" />
        <p className={styles.basketBarText}>Ver minha cesta</p>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => ({
  visible: state.BasketReducer.offers.length > 0,
});

BasketBar.propTypes = {
  visible: PropTypes.bool,
};

export default connect(mapStateToProps)(BasketBar);
